// function waitForWidgetAndUpdate() {
//     const widget = document.querySelector('#reviewsio-carousel-widget');
//     if (widget) {

//         const innerObserver = new MutationObserver((mutations, obs) => {
//             const ratingElements = document.querySelectorAll(
//                 "#reviewsio-carousel-widget .CarouselWidget__header .cssVar-subheading__number"
//             );

//             if (ratingElements.length >= 2) {

//                 updateReviewData();
//                 obs.disconnect();
//             }
//         });

//         innerObserver.observe(widget, {
//             childList: true,
//             subtree: true,
//         });

//         return true;
//     }

//     return false;
// }

// async function checkReviewCount() {
//     const options = { method: 'GET', headers: { accept: 'application/json' } };

//     try {
//         const res = await fetch('https://api.reviews.io/reviews?store=jimmyjoy.com&apikey=c349e5e93e4548f7ed1b3bef6ec8201b', options);
//         const data = await res.json();
//         return data;
//     } catch (err) {

//         return null;
//     }
// }
// async function updateReviewData() {
//     const reviewData = await checkReviewCount();
//     if (!reviewData) return;

//     const averageRating = reviewData.average_rating;
//     const review_count = reviewData.review_count;

//     const ratingElements = document.querySelectorAll(
//         "#reviewsio-carousel-widget .CarouselWidget__header .cssVar-subheading__number"
//     );

//     if (ratingElements.length >= 2) {
//         if (ratingElements[0]) {
//             ratingElements[0].innerText = `${averageRating}`;
//         }
//         if (ratingElements[1]) {
//             ratingElements[1].innerText = `${review_count.toLocaleString()} `;
//         }

//         const rating = `${averageRating}`;
//         const ratingContainer = document.querySelector('.header__inner .R-RatingStars');
//         if (ratingContainer) {
//             ratingContainer.innerHTML = `
//         <label class="rating-label">
//           <input
//             class="rating-custom"
//             max="5"
//             readonly
//             step="0.01"
//             style="--fill:#FDD672;--value:${rating};background-color: #c4e8e3;"
//             type="range"
//             value="${rating}">
//         </label>
//       `;

//         }
//         appendCSSToRatingLabel();
//     } else {
//         // console.warn("⚠️ Review elements not found at time of update.");
//     }
// }

// function appendCSSToRatingLabel() {
//     const ratingLabel = document.querySelector('.rating-label');
//     if (ratingLabel) {
//         const style = document.createElement('style');
//         style.innerHTML = `
//         .rating-custom {
//           --dir: right;
//           --fill: gold;
//           --fillbg: rgba(100, 100, 100, 0.15);
//           --heart: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 21.328l-1.453-1.313q-2.484-2.25-3.609-3.328t-2.508-2.672-1.898-2.883-0.516-2.648q0-2.297 1.57-3.891t3.914-1.594q2.719 0 4.5 2.109 1.781-2.109 4.5-2.109 2.344 0 3.914 1.594t1.57 3.891q0 1.828-1.219 3.797t-2.648 3.422-4.664 4.359z"/></svg>');
//           --star: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 17.25l-6.188 3.75 1.641-7.031-5.438-4.734 7.172-0.609 2.813-6.609 2.813 6.609 7.172 0.609-5.438 4.734 1.641 7.031z"/></svg>');
//           --stars: 5;
//           --starsize: 22px;
//           --symbol: var(--star);
//           --value: 1;
//           --w: calc(var(--stars) * var(--starsize));
//           --x: calc(100% * (var(--value) / var(--stars)));
//           block-size: var(--starsize);
//           inline-size: var(--w);
//           position: relative;
//           touch-action: manipulation;
//           -webkit-appearance: none;
//         }
//         [dir="rtl"] .rating-custom {
//           --dir: left;
//         }
//         .CarouselWidget-prefix .CarouselWidget--topHeader .CarouselWidget__header .header__inner {
//           align-items: center;
//         }
//         .CarouselWidget-prefix .CarouselWidget--topHeader .CarouselWidget__header .header__inner .rating-label {
//           margin-block-end: 10px;
//         }

//         .rating-custom::-moz-range-track {
//           background: linear-gradient(to var(--dir), var(--fill) 0 var(--x), var(--fillbg) 0 var(--x));
//           block-size: 100%;
//           mask: repeat left center/var(--starsize) var(--symbol);
//         }
//         .rating-custom::-webkit-slider-runnable-track {
//           background: linear-gradient(to var(--dir), var(--fill) 0 var(--x), var(--fillbg) 0 var(--x));
//           block-size: 100%;
//           mask: repeat left center/var(--starsize) var(--symbol);
//           -webkit-mask: repeat left center/var(--starsize) var(--symbol);
//         }
//         .rating-custom::-moz-range-thumb {
//           height: var(--starsize);
//           opacity: 0;
//           width: var(--starsize);
//         }
//         .rating-custom::-webkit-slider-thumb {
//           height: var(--starsize);
//           opacity: 0;
//           width: var(--starsize);
//           -webkit-appearance: none;
//         }
//         .rating-custom, .rating-label {
//           display: block;
//           font-family: ui-sans-serif, system-ui, sans-serif;
//         }
//         .rating-label {
//           margin-block-end: 1rem;
//         }
//         .rating--nojs::-moz-range-track {
//           background: var(--fillbg);
//         }
//         .rating--nojs::-moz-range-progress {
//           background: var(--fill);
//           block-size: 100%;
//           mask: repeat left center/var(--starsize) var(--star);
//         }
//         .rating--nojs::-webkit-slider-runnable-track {
//           background: var(--fillbg);
//         }
//         .rating--nojs::-webkit-slider-thumb {
//           background-color: var(--fill);
//           box-shadow: calc(0rem - var(--w)) 0 0 var(--w) var(--fill);
//           opacity: 1;
//           width: 1px;
//         }
//         [dir="rtl"] .rating--nojs::-webkit-slider-thumb {
//           box-shadow: var(--w) 0 0 var(--w) var(--fill);
//         }
//       `;
//         ratingLabel.appendChild(style);
//     }
// }
// if (!waitForWidgetAndUpdate()) {
//     const outerObserver = new MutationObserver((mutations, obs) => {
//         if (waitForWidgetAndUpdate()) {
//             obs.disconnect();
//         }
//     });

//     outerObserver.observe(document.body, {
//         childList: true,
//         subtree: true,
//     });
// }
function updateHeaderOffset() {
    const announcementBar = document.querySelector(
        '.announcement-bar.original_cro:not(.hidden)'
    );
    const header = document.querySelector('.header');
    const headerWrapper = document.querySelector('.header__wrapper');
    if (!headerWrapper || !header) return;
    // Get height or fallback to 0
    const barHeight = announcementBar ? announcementBar.offsetHeight - 1 : 0;
    // Store in CSS variable
    document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${barHeight}px`
    );
    // Update body spacing
    document.body.style.paddingTop = `${barHeight}px`;
    // Sticky header offset
    if (header.classList.contains('is-sticky')) {
        headerWrapper.style.top = `var(--announcement-bar-height)`;
    } else {
        headerWrapper.style.top = '';
    }
}
// Run on load
window.addEventListener('load', updateHeaderOffset);
// Update on resize
window.addEventListener('resize', updateHeaderOffset);
// Run immediately
updateHeaderOffset();
// Better than scroll listener spam
window.addEventListener('load', updateHeaderOffset);
window.addEventListener('resize', updateHeaderOffset);
// Observe sticky class changes
const header = document.querySelector('.header');
if (header) {
    const observer = new MutationObserver(updateHeaderOffset);
    observer.observe(header, {
        attributes: true,
        attributeFilter: ['class']
    });
}
function adjustMobileNav() {
    const header = document.querySelector('#shopify-section-jj-header');
    const marquee = document.querySelector('.marquee-bar');
    const mobileNav = document.querySelector('.nav--mobile.js-mobile-nav');
    const mainannouncement = document.querySelectorAll('.announcement-bar.original_cro:not(.hidden)');
    const announcement = document.querySelector('.main-bg-ann');


    if (!header || !mobileNav) return;

    // Get header height
    let headerHeight = header.offsetHeight;

    // Add marquee height if present
    let marqueeHeight = marquee ? marquee.offsetHeight : 0;
    let mainannouncementHeight = mainannouncement.length > 0 ? mainannouncement[0].offsetHeight : 0;
    // Add announcement bar height if visible
    const announcements = document.querySelectorAll('.main-bg-ann');

    let announcementHeight = 0;

    announcements.forEach(banner => {
        if (banner && window.getComputedStyle(banner).display !== 'none') {
            announcementHeight += banner.offsetHeight;
        }
    });

    const isCartPage = window.location.pathname.includes('/cart');

    // Total height = header + marquee
    const totalHeight =
    headerHeight +
    marqueeHeight +
    announcementHeight +
    (isCartPage ? 0 : Math.max(0, mainannouncementHeight - 2));
     document.documentElement.style.setProperty(
            '--header-height',
            `${totalHeight}px`
        );
    // Apply top position
    if (mobileNav.classList.contains('is-open')) {
        mobileNav.style.top = totalHeight + "px";
    }
}

// Adjust on menu open (example: toggle button)
document.querySelectorAll('.hamburger.js-hamburger').forEach(btn => {

    btn.addEventListener('click', () => {
        // Wait for class toggle
        adjustMobileNav();
        setTimeout(adjustMobileNav, 50);
    });
});

// Adjust on window resize to handle responsive changes
window.addEventListener('resize', adjustMobileNav);
window.addEventListener('load', adjustMobileNav);
document.addEventListener('DOMContentLoaded', adjustMobileNav);

const bodyObserver = new MutationObserver(() => {
    const banner = document.querySelector('.main-bg-ann');

    if (banner) {
        adjustMobileNav();

        const bannerObserver = new MutationObserver(adjustMobileNav);

        bannerObserver.observe(banner, {
            attributes: true,
            childList: true,
            subtree: true
        });

        bodyObserver.disconnect(); // stop once banner is found
    }
});

bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
});
if (window.location.pathname.includes('/products/plenny-shake-active')) {
    window.location.replace('/products/plenny-shake-pro');
}
if (window.location.pathname.includes('/collections/plenny-shake-active')) {
    window.location.replace('/collections/all');
}
if (window.location.pathname.includes('/pages/introduction-to-plenny-shake-active')) {
    window.location.replace('/pages/introduction-to-plenny-shake-pro-v4');
}
if (window.location.pathname.includes('/pages/plenny-shake-active-v3-1-vs-v3-2-what-changed')) {
    window.location.replace('/pages/plenny-shake-active-v3-2-vs-pro-v4-what-changed');
}
const banner = document.querySelector('.main-bg-ann--spain.main-bg-ann');
const footerActions = document.querySelector('.cro-menu__footer-actions');
if (banner && footerActions) {
    const observer = new MutationObserver(() => {
        const style = window.getComputedStyle(banner);
        if (style.display === 'block') {
            footerActions.style.marginBottom = '130px';
        } else {
            footerActions.style.marginBottom = '';
        }
    });
    observer.observe(banner, { attributes: true, attributeFilter: ['style', 'class'] });
}